import { format, isSameDay, isSameWeek, subDays } from "date-fns"

export interface DayGroup<T> {
	key: string
	label: string
	versions: T[]
}

function dayLabel(date: Date, now: Date): string {
	if (isSameDay(date, now)) return "Today"
	if (isSameDay(date, subDays(now, 1))) return "Yesterday"
	if (isSameWeek(date, now)) return format(date, "EEEE")
	if (date.getFullYear() === now.getFullYear()) return format(date, "MMMM d")
	return format(date, "MMMM d, yyyy")
}

// Newest first, one group per calendar day, so the sidebar reads like a journal
// instead of a flat list of timestamps.
export function groupVersionsByDay<T extends { createdAt: number }>(
	versions: readonly T[],
	now: Date = new Date(),
): DayGroup<T>[] {
	const sorted = [...versions].sort((a, b) => b.createdAt - a.createdAt)
	const groups: DayGroup<T>[] = []

	for (const version of sorted) {
		const date = new Date(version.createdAt)
		const key = format(date, "yyyy-MM-dd")
		const last = groups[groups.length - 1]
		if (last?.key === key) {
			last.versions.push(version)
			continue
		}
		groups.push({ key, label: dayLabel(date, now), versions: [version] })
	}

	return groups
}
